module.exports = __webpack_public_path__ + "img/hyundai.a0820cb3.png";